import type { ButtonProps } from "antd";
import type { MouseEventHandler } from "react";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useMarkAllNotificationsAsRead } from "@/entities/notifications";

export const NotificationsMarkAllButton = ({
  onClick,
  loading,
  ...props
}: ButtonProps) => {
  const { t } = useTranslation();
  const { markAllAsRead, isPending } = useMarkAllNotificationsAsRead();

  const onButtonClick: MouseEventHandler<HTMLElement> = (e) => {
    markAllAsRead();
    onClick?.(e);
  };

  return (
    <Button loading={isPending || loading} onClick={onButtonClick} {...props}>
      {t("notification:markAllButton")}
    </Button>
  );
};
